// @flow

import React from 'react';
import styled from 'styled-components';
import { flex, topMargin, Width } from 'styles';
import { BlockyContentItems } from 'templates';

const Wrapper = styled.section`
  ${flex()};
  ${({ marginTop }) => marginTop && topMargin(...marginTop)};
  flex-direction: column;

  @media print, screen and (min-width: ${Width.BREAK_MD}px) {
    max-width: 688px;
    margin-left: auto;
    margin-right: auto;
    justify-content: space-between;
    flex-direction: row;
  }

  > div {
    &:first-of-type {
      margin-bottom: 24px;

      @media print, screen and (min-width: ${Width.BREAK_MD}px) {
        margin-bottom: 0;
      }
    }

    @media print, screen and (min-width: ${Width.BREAK_MD}px) {
      width: calc(50% - 12px);
      flex: 0 0 auto;
    }

    @media print, screen and (min-width: ${Width.BREAK_XL}px) {
      width: calc(50% - 8px);
    }
  }
`;

type Props = {
  marginTop?: number[],
  content: any[],
};

const BlockyFlexContainer = ({ marginTop, content, ...rest }: Props) => (
  <Wrapper marginTop={marginTop}>
    {content.map((itemContent, index) => (
      <BlockyContentItems key={`BlockyFlexContainer-${index}`} {...rest} {...itemContent} />
    ))}
  </Wrapper>
);

BlockyFlexContainer.contentType = 'BlockyFlexContainer';

export default BlockyFlexContainer;
